import { AffiliateService } from '@services/AffiliateService';

type IOption = {
  value: string;
  label: string;
};

export const CHESS_RUSSIAN_CLUB_ID = '777';

// --------------------------------

// Тикеты: Маркеры разделов
//

// Школьный абонемент. Даёт доступ к школьным турнирам.
export const SCHOOL_TICKET = 'school';

// Гран-при
export const GRAND_PRIX_TICKET = 'grand-prix';
export const GRAND_PRIX_SECTION_TICKETS = [GRAND_PRIX_TICKET];

// Рейтинг ФШР (премиум)
export const PREMIUM_RCF_TICKET = 'premium-rcf';
export const PREMIUM_RCF_SECTION_TICKETS = [PREMIUM_RCF_TICKET];

// Тикеты: Абонементы
//

// Премиум подписка (на месяц/год и т.п.)
export const SUBSCRIPTION_TICKET = 'subscription';

// Абонемент на блок турниров
export const PER_EVENT_TICKET = 'per-event';
export const PER_EVENT_COUNTER = `count`;
export const PER_EVENT_TICKET_WITH_COUNTER = `${PER_EVENT_TICKET}:${PER_EVENT_COUNTER}`;

// Параметры
//

export const SCHOOL_ELOS = [[0, 200], [200, 600], [600, 1000], [1000, 1300], [1300]];
export const SCHOOL_ELO_TICKET_PREFIX = `elo-`;
export const SCHOOL_ELO_OPTIONS = buildEloOptions(SCHOOL_ELOS, SCHOOL_ELO_TICKET_PREFIX);

export const PREMIUM_RCF_ELOS = [[0, 1300], [1300, 1700], [1700]];
export const PREMIUM_RCF_ELO_TICKET_PREFIX = 'rcf-elo-';
export const PREMIUM_RCF_ELO_OPTIONS = [
  { value: `${PREMIUM_RCF_ELO_TICKET_PREFIX}any`, label: 'Без ограничений' },
  ...buildEloOptions(PREMIUM_RCF_ELOS, PREMIUM_RCF_ELO_TICKET_PREFIX),
];
// FIXME: решить, а нужен ли нам второй этаж
// export const PREMIUM_RCF_SECTION_SUBTABS = [
//   { value: '', label: 'Все' },
//   ...PREMIUM_RCF_ELO_OPTIONS,
// ] as const;

export const GRAND_PRIX_AGES = [11, 15, 19];
export const GRAND_PRIX_AGE_TICKET_PREFIX = `age-till-`;
export const GRAND_PRIX_AGE_OPTIONS: IOption[] = [
  { value: `${GRAND_PRIX_AGE_TICKET_PREFIX}any`, label: 'Без ограничений' },
  ...GRAND_PRIX_AGES.map((a) => ({
    value: `${GRAND_PRIX_AGE_TICKET_PREFIX}${a}`,
    label: `до ${a} лет`,
  })),
];

// --------------------------------

// FIXME: поменять на страницу премиум-аккаунта
export const PREMIUM_ACCOUNT_PAGE = '/grandprix';

export const GRAND_PRIX_PROMO_PAGE = '/grandprix';
export const GRAND_PRIX_PROMO_PAGE_PRICES = `${GRAND_PRIX_PROMO_PAGE}#prices`;

export const PREMIUM_RCF_PROMO_PAGE = 'https://chessopen.ru/autumn/';

// --------------------------------

const MONTHLY_PRODUCT_ID = 151103;
const YEARLY_PRODUCT_ID = 151104;
const SUMMER_PRODUCT_ID = 173556;
const ONE_TOURNAMENT_ID = 167607;
const FIVE_TOURNAMENTS_ID = 167608;
const TEN_TOURNAMENTS_ID = 167609;
const MONTHLY_DISCOUNT_PRODUCT_ID = 151111;
const YEARLY_DISCOUNT_PRODUCT_ID = 151110;
const ONE_TOURNAMENT_DISCOUNT_ID = 167610;
const FIVE_TOURNAMENTS_DISCOUNT_ID = 167611;
const TEN_TOURNAMENTS_DISCOUNT_ID = 167612;

export const LINK_PREMIUM_MONTHLY = createChessOpenCartLink(MONTHLY_PRODUCT_ID);
export const LINK_PREMIUM_YEARLY = createChessOpenCartLink(YEARLY_PRODUCT_ID);
export const LINK_PREMIUM_BOTH = createChessOpenCartLink(MONTHLY_PRODUCT_ID, YEARLY_PRODUCT_ID);
export const LINK_PREMIUM_SUMMER = createChessOpenCartLink(SUMMER_PRODUCT_ID);
export const LINK_PREMIUM_ONE_TOURNAMENT = createChessOpenCartLink(ONE_TOURNAMENT_ID);
export const LINK_PREMIUM_FIVE_TOURNAMENTS = createChessOpenCartLink(FIVE_TOURNAMENTS_ID);
export const LINK_PREMIUM_TEN_TOURNAMENTS = createChessOpenCartLink(TEN_TOURNAMENTS_ID);
export const LINK_PREMIUM_MONTHLY_DISCOUNT = createChessOpenCartLink(MONTHLY_DISCOUNT_PRODUCT_ID);
export const LINK_PREMIUM_YEARLY_DISCOUNT = createChessOpenCartLink(YEARLY_DISCOUNT_PRODUCT_ID);
export const LINK_PREMIUM_BOTH_DISCOUNT = createChessOpenCartLink(
  MONTHLY_DISCOUNT_PRODUCT_ID,
  YEARLY_DISCOUNT_PRODUCT_ID,
);
export const LINK_PREMIUM_ONE_TOURNAMENT_DISCOUNT = createChessOpenCartLink(
  ONE_TOURNAMENT_DISCOUNT_ID,
);
export const LINK_PREMIUM_FIVE_TOURNAMENTS_DISCOUNT = createChessOpenCartLink(
  FIVE_TOURNAMENTS_DISCOUNT_ID,
);
export const LINK_PREMIUM_TEN_TOURNAMENTS_DISCOUNT = createChessOpenCartLink(
  TEN_TOURNAMENTS_DISCOUNT_ID,
);

//

export const PRICE_PREMIUM_MONTHLY = '2900';
export const PRICE_PREMIUM_MONTHLY_DISCOUNT = '2610';
export const PRICE_PREMIUM_ONE_TOURNAMENT = '800';
export const PRICE_PREMIUM_ONE_TOURNAMENT_DISCOUNT = '720';
export const PRICE_PREMIUM_FIVE_TOURNAMENTS = '2900';
export const PRICE_PREMIUM_FIVE_TOURNAMENTS_DISCOUNT = '2610';
export const PRICE_PREMIUM_TEN_TOURNAMENTS = '4900';
export const PRICE_PREMIUM_TEN_TOURNAMENTS_DISCOUNT = '4410';

export const PRICE_PREMIUM_YEARLY = '24 000';
export const PRICE_PREMIUM_YEARLY_DISCOUNT = '21 600';
export const PRICE_PREMIUM_SUMMER = '7 000';

//
export const LINK_TOURNAMENTS = `/club/${CHESS_RUSSIAN_CLUB_ID}`;
//
export const LINK_GRANDPRIX_TOURNAMENTS_BLITZ = `${LINK_TOURNAMENTS}?grandprix=blitz#grandprix`;
export const LINK_GRANDPRIX_TOURNAMENT_RULES_BLITZ =
  'https://storage.yandexcloud.net/chessopen.ru/grandprix/blitz.pdf';
export const LINK_GRANDPRIX_TELEGRAM_BLITZ = 'https://t.me/chessrussian_tournament/7389';
//
export const LINK_GRANDPRIX_TOURNAMENTS_RAPID = `${LINK_TOURNAMENTS}?grandprix=rapid#grandprix`;
export const LINK_GRANDPRIX_TOURNAMENT_RULES_RAPID =
  'https://storage.yandexcloud.net/chessopen.ru/grandprix/rapid.pdf';
export const LINK_GRANDPRIX_TELEGRAM_RAPID = 'https://t.me/chessrussian_tournament/7563';

export const LINK_SUMMER_TOURNAMENTS = `${LINK_TOURNAMENTS}?rcf=tournaments#rcf`;
export const LINK_SUMMER_TOURNAMENT_RULES_BLITZ = 'https://disk.yandex.ru/i/elGE2QsQ85D61A';
export const LINK_SUMMER_TOURNAMENT_RULES_RAPID = 'https://disk.yandex.ru/i/BKOeNT2KH88psA';
export const LINK_SUMMER_TELEGRAM_CHANNEL = 'https://t.me/chessrussian_tournament/12464';

export const LINK_TELEGRAM_CHANNEL = 'https://t.me/chessrussian_tournament';

function createChessOpenCartLink(...products: number[]) {
  const back = AffiliateService.instance.appendToUrl(
    `/oplaty/buy/?${products.map((p, i) => `id${i ? i + 1 : ''}=${p}`).join('&')}`,
  );
  const baseUrl = `https://id.chessopen.ru/?source=ChessOpen&for=subscription&back=${encodeURIComponent(back)}`;
  return baseUrl;
}

function buildEloOptions(elos: number[][], prefix: string): IOption[] {
  return elos.map((e) => ({
    value: `${prefix}${e.join('-')}`,
    label: `${e[0]}${e[1] ? ` — ${e[1]}` : '+'}`,
  }));
}
